import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';

const ViewDetailsContainer = styled(Box, {
  name: 'view-details-container',
  slot: 'Root',
})(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

const HeaderContainer = styled(Box, {
  name: 'library-header-container',
  slot: 'Root',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1),
  // borderBottom: `1px solid ${theme.palette.primary.main}`,
}));

const ContentContainer = styled(Box, {
  name: 'content-container',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: '100%',
  flex: 1,
  minHeight: 0,
  gap: 2,
}));

const ViewHeaderContainer = styled(Box, {
  name: 'view-header-container',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

const GroupActionButtonsContainer = styled(Box, {
  name: 'group-button-container',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
}));

const DetailsContainer = styled(Box, {
  name: 'details-container',
  slot: 'Root',
})(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  overflow: 'hidden',
}));

const ViewPanelContainer = styled(Box, {
  name: 'view-panel-container',
  slot: 'Root',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '70%',
  height: '100%',
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: '4px',
  padding: '16px',
}));

const EmptyTreeContainer = styled(Box, {
  name: 'empty-tree-container',
  slot: 'Root',
})(() => ({
  width: '30%',
  height: '100%',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

const AthenaTreeItem = styled(TreeItem)(({ theme }) => ({
  color: theme.palette.grey[200],
  [`& .${treeItemClasses.content}`]: {
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    margin: theme.spacing(0.2, 0),
    [`& .${treeItemClasses.label}`]: {
      // 0.875rem (14px) matches MUI DataGrid's default cell font size, so the
      // library tree items read at the same weight as deliverables/projects rows.
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    // Hover-reveal drag handle (Notion/Asana pattern). The handle is rendered
    // by CustomLabel and starts at opacity 0; hovering anywhere on the row
    // fades it in. MUI X tree-view drag is row-level, so the handle is a
    // visual hint — users can grab anywhere on the row to drag.
    '& .library-drag-handle': {
      opacity: 0,
      transition: 'opacity 120ms ease',
    },
    '&:hover .library-drag-handle': {
      opacity: 1,
    },
  },
  [`& .${treeItemClasses.groupTransition}`]: {
    marginLeft: 15,
    paddingLeft: 18,
    borderLeft: `1px dashed ${alpha('#0092CB', 0.4)}`,
  },
  ...theme.applyStyles('light', {
    color: theme.palette.grey[800],
  }),
}));

export {
  AthenaTreeItem,
  ContentContainer,
  DetailsContainer,
  EmptyTreeContainer,
  GroupActionButtonsContainer,
  HeaderContainer,
  ViewDetailsContainer,
  ViewHeaderContainer,
  ViewPanelContainer,
};
